<div class="avano-search-toggle-group" role="group" [class.avano-search-toggle-disabled-advanced]='disableAdvanced'>
  <div
    class="avano-search-toggle-button"
    role="button"
    [ngClass]="{
      'avano-search-toggle-selected': value === searchType.QUICK
    }"
    (click)="onItemClick($event, searchType.QUICK)"
    (keydown.enter)="onItemClick($event, searchType.QUICK)"
    (blur)="onBlur()"
    [attr.aria-labelledby]="quickLabel"
  >
    <span class="avano-search-toggle-label">{{ quickLabel }}</span>
  </div>
  <div
    class="avano-search-toggle-button avano-search-toggle-button-advanced"
    role="button"
    [ngClass]="{
      'avano-search-toggle-selected': value === searchType.ADVANCED
    }"
    (click)="onItemClick($event, searchType.ADVANCED)"
    (keydown.enter)="onItemClick($event, searchType.ADVANCED)"
    (blur)="onBlur()"
    [attr.aria-labelledby]="advancedLabel"
  >
    <span class="avano-search-toggle-label">{{ advancedLabel }}</span>
  </div>
</div>
